var _ = require("underscore");
var cio_datamodel = require("cio-datamodel");
var toSVGutil = require("./toSVGutil");

var drawEllipseDataTo2D = function (svg, group, data, attrs) {
    console.assert(data instanceof cio_datamodel.EllipseData);
    var attrs_total = {
        transform: toSVGutil.rotateTransform(data),
    };
    _.extend(attrs_total, toSVGutil.styleToAttributes(data));
    if(attrs) _.extend(attrs_total, attrs);

    return svg.ellipse(group,
        data.pos().getX(),
        data.pos().getY(),
        data.width()/2,
        data.height()/2,
        attrs_total);
};

module.exports = drawEllipseDataTo2D;

// EllipseData.prototype.fromSVG = function (svg) {
//     var svgObject = $(svg);

//     this.pos(new lib_geometry.Coord(parseFloat(svgObject.attr('cx')), parseFloat(svgObject.attr('cy'))));
//     this.radius(parseFloat(svgObject.attr('r')));

//     SvgHelpers.getSvgStyleProperties(this, svgObject);
// };
